"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getValidation;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _flatten2 = _interopRequireDefault(require("lodash/flatten"));

var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));

var _validation = require("@sift/validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSubvalueKey(objectKey) {
  var objectKeySplit = objectKey.split('.');
  var subvalueKey = objectKeySplit[objectKeySplit.length - 1];
  return subvalueKey;
} // TODO: don't validate fields that are `valueReadOnly`


function getValidation(value, node, config) {
  var validation = (0, _get2.default)(node, ['validation']);

  if (validation) {
    var field = node;
    var objectKey = field.objectKey;
    var deepClonedValue = (0, _cloneDeep2.default)(value);
    var errors = (0, _validation.validateValue)(config.fields, objectKey, field, deepClonedValue);
    var errorMessages = (0, _flatten2.default)(errors.map(function (e) {
      return e.messages;
    }));
    return {
      errorMessages: errorMessages,
      errors: errors,
      isValid: errors.length <= 0
    };
  }

  var children = (0, _get2.default)(node, ['children']);

  if (children) {
    var validationChildren = children.map(function (_ref) {
      var configPath = _ref.configPath;
      var childLayoutObject = (0, _get2.default)(config, configPath);
      var objectKey = (0, _get2.default)(childLayoutObject, ['objectKey']);
      var nextValue = objectKey ? (0, _get2.default)(value, [getSubvalueKey(objectKey)]) : value;
      return getValidation(nextValue, childLayoutObject, config);
    });

    var _errors = validationChildren.reduce(function (combinedErrors, next) {
      var errors = next.errors || [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var error = _step.value;
          combinedErrors.push(error);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return combinedErrors;
    }, []);

    var isValid = validationChildren.every(function (result) {
      return result.isValid;
    });

    var _errorMessages = (0, _flatten2.default)(_errors.map(function (e) {
      return e.messages;
    }));

    return {
      isValid: isValid,
      errors: _errors,
      errorMessages: _errorMessages
    };
  }

  return {
    isValid: true,
    errors: [],
    errorMessages: []
  };
}